import getTagOfNode from '../utils/getTagOfNode';
export default function getListTypeFromNode(node) {
    switch (getTagOfNode(node)) {
        case 'OL':
            return 1 /* Ordered */;
        case 'UL':
            return 2 /* Unordered */;
        default:
            return 0 /* None */;
    }
}
/**
 * @internal
 * Check if the given DOM node is a list element (OL or UL)
 * @param node The node to check
 */
export function isListElement(node) {
    return getListTypeFromNode(node) != 0 /* None */;
}
//# sourceMappingURL=getListTypeFromNode.js.map